import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchMaterialSpecs,
  createMaterialSpec,
  updateMaterialSpec,
  deleteMaterialSpec,
  mergeMaterialSpec
} from '../api/materialSpecsApi';

const KEY = ['material-specs'];

/**
 * The catalogue, optionally narrowed to one phase.
 *
 * `usedIn` is what keeps the picker useful: choosing an inner sheath should not
 * mean scrolling past every insulation colour the factory has ever run.
 */
export function useMaterialSpecs(filters = {}) {
  return useQuery({
    queryKey: [...KEY, filters],
    queryFn: () => fetchMaterialSpecs(filters),
    // A catalogue changes when somebody edits it, not on its own.
    staleTime: 5 * 60 * 1000
  });
}

function useInvalidating(mutationFn) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY })
  });
}

export const useCreateMaterialSpec = () => useInvalidating(createMaterialSpec);
export const useUpdateMaterialSpec = () =>
  useInvalidating(({ id, ...body }) => updateMaterialSpec(id, body));
export const useDeleteMaterialSpec = () => useInvalidating(deleteMaterialSpec);
export const useMergeMaterialSpec = () =>
  useInvalidating(({ id, intoId }) => mergeMaterialSpec(id, intoId));
